var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlineCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 162,
    viewBox: "0 0 168 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_827_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.519 0H59.4395C55.8545 1.09879 52.3468 2.43508 48.9395 4H118.999C115.599 2.43387 112.098 1.09754 108.519 0V0Z",
    fill: "#F8D045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 14.3501H31.9998C30.3698 15.6301 28.7798 16.9601 27.2598 18.3501H140.69C139.17 17.0001 137.57 15.6301 136 14.3501Z",
    fill: "#F8D045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.26 28.71H17.7C16.7 30.01 15.7 31.34 14.75 32.71H153.21C152.27 31.34 151.28 30 150.26 28.71Z",
    fill: "#F8D045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.32 43.0601H8.63953C7.98953 44.3701 7.35953 45.7101 6.76953 47.0601H161.18C160.6 45.7101 160 44.3701 159.32 43.0601Z",
    fill: "#F8D045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.87 57.4099H3.08984C2.70984 58.7299 2.36984 60.0699 2.08984 61.4099H165.9C165.59 60.0699 165.25 58.7299 164.87 57.4099Z",
    fill: "#F8D045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.65 71.76H0.31C0.17 73.09 0.07 74.42 0 75.76H168C167.88 74.42 167.79 73.09 167.65 71.76Z",
    fill: "#F8D045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.430313 90.1201H167.53C167.68 88.7901 167.8 87.4601 167.89 86.1201H0.0703125C0.160313 87.4601 0.280313 88.7901 0.430313 90.1201Z",
    fill: "#F8D045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.35953 104.47H164.6C165 103.15 165.36 101.82 165.68 100.47H2.26953C2.59953 101.82 2.99953 103.15 3.35953 104.47Z",
    fill: "#F8D045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11922 118.82H158.839C159.509 117.51 160.149 116.18 160.759 114.82H7.19922C7.80922 116.18 8.44922 117.51 9.11922 118.82Z",
    fill: "#F8D045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4399 133.18H149.52C150.52 131.88 151.52 130.54 152.52 129.18H15.4199C16.3899 130.54 17.3899 131.88 18.4399 133.18Z",
    fill: "#F8D045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2098 147.53H134.75C136.43 146.26 138.05 144.92 139.62 143.53H28.3398C29.9098 144.92 31.5298 146.26 33.2098 147.53Z",
    fill: "#F8D045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.75 161.88H105.2C109.204 160.84 113.125 159.503 116.93 157.88H51C54.8118 159.503 58.7394 160.84 62.75 161.88Z",
    fill: "#F8D045"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_827_25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 167.96,
    height: 161.88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineCircle);
export default __webpack_public_path__ + "static/media/outline_circle.a86ddc65253cd25ee0c0e64a6188a82e.svg";
export { ForwardRef as ReactComponent };